// Solution lauout
export const HEADER_HEIGHT = 150 as const;
export const SIDEBAR_WIDTH = 320 as const;

// Table layout
export const COLLAPSED_COLUMN_WIDTH = 100 as const;
export const EXPANDED_COLUMN_WIDTH = 330 as const;
export const COLLAPSED_ROW_HEIGHT = 138 as const;
export const MIN_EXPANDED_ROW_HEIGHT = 180 as const;

export const TASK_HEIGHT = 30 as const;
export const TASK_CELL_PADDING = 72 as const;
export const COLUMNS_START_PADDING = 4 as const;

// Solution view layout
export const APPLICATION_ROW_TASK_HEIGHT = 60 as const;
export const APPLICATION_TASK_TAB_PAD_HEIGHT = 40 as const;

// Organization view layout
export const ORGANIZATION_MIN_EXPANDED_GROUP_HEIGHT = 350 as const;

export const INNER_Y_PADDING = 16 as const;
export const ORGANIZATION_APPPLICATION_GUTTER = 24 as const;

// Unnasigned view layout
export const UNASSIGNED_Y_PADDING = 32 as const;
export const UNASSIGNED_COLUMNS = 4 as const;
export const UNASSIGNED_GAP = 16 as const;
